import { render, staticRenderFns } from "./PriceLot.vue?vue&type=template&id=c70bc14a&"
import script from "./PriceLot.vue?vue&type=script&lang=js&"
export * from "./PriceLot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports